import { PropsWithChildren, useEffect } from 'react';
import TranslationService from 'services/TranslationService';

const LocalizationProvider = ({ children }: PropsWithChildren<{}>) => {
  useEffect(() => {
    TranslationService.initialize();
  }, []);

  return <>{children}</>;
};

export default LocalizationProvider;
